import React, { Component } from "react";
import {
    Button,
    Modal,
    Icon
} from "semantic-ui-react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { createNotification } from "react-redux-notify";

class ConfirmationModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    onClose = () => {
        this.props.closePopup();
    };

    discardChanges = () => {
        this.props.discardChangesYes();
    }

    deleteLocation = () => {
        this.props.deleteLocation();
    }

    render() {
        return (
            <Modal
                open={this.props.showPopup}
                closeOnDimmerClick={false}
                centered={true}
                size="tiny">
                <Modal.Header>
                    <strong>Warning</strong>
                    <Icon
                        className="confirmBoxAlign"               
                        name="close"
                        onClick={this.onClose}  
                    />
                </Modal.Header>
                <Modal.Content
                    scrolling={true}>
                    {this.props.isDeleteLocation ? (
                        <p>Are you sure you want to delete this location?</p> ) :
                        (<p>The changes you have made will be deleted. Do you want to proceed?</p>)
                    }
                </Modal.Content>
                <Modal.Actions>
                    <Button
                        content="No"
                        onClick={this.onClose}
                    />
                    <Button
                        content={"Yes"}
                        primary
                        onClick={
                            this.props.isDeleteLocation ?
                                (this.deleteLocation)
                                : (this.discardChanges)
                        }
                    />
                </Modal.Actions>
            </Modal>
        );
    }
}
function mapDispatchToProps(dispatch) {
    return bindActionCreators(
        {
            createNotification,
        },
        dispatch
    );
}

export default connect(
    mapDispatchToProps
)(ConfirmationModal);
